var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetricsIconHovered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7184 15.3944C15.5335 18.1063 12.8274 20.0016 9.67865 20.0016C5.43785 20.0016 2 16.5637 2 12.3229C2 9.17417 3.89524 6.4681 6.60719 5.2832",
    stroke: "#153230",
    strokeWidth: 1.65084,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37158 3.54764V11.0928C9.37158 11.9409 10.0592 12.6285 10.9073 12.6285H18.4525C19.3826 12.6285 20.1307 11.8024 19.9809 10.8844C19.2403 6.34436 15.6557 2.75985 11.1157 2.01917C10.1977 1.86943 9.37158 2.61752 9.37158 3.54764Z",
    stroke: "#153230",
    strokeWidth: 1.65084,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricsIconHovered);
export default __webpack_public_path__ + "static/media/metrics_icon_hovered.0d55adfe6d218df36209ef65ebb770e8.svg";
export { ForwardRef as ReactComponent };